"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundStatus = exports.RefundType = void 0;
var RefundType;
(function (RefundType) {
    RefundType["REFUND"] = "refund";
    RefundType["VOID"] = "void";
})(RefundType || (exports.RefundType = RefundType = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "pending";
    RefundStatus["REFUNDED"] = "refunded";
    RefundStatus["FAILED"] = "failed";
    RefundStatus["UNKNOWN"] = "unknown";
})(RefundStatus || (exports.RefundStatus = RefundStatus = {}));
//# sourceMappingURL=enums.js.map